import React from 'react'
import _ from 'lodash/fp'

import { makeStyles } from '@material-ui/core/styles'

import Button from './Button'

import ChevronLeftIcon from '@material-ui/icons/ChevronLeft'
import ChevronRightIcon from '@material-ui/icons/ChevronRight'

import colors from '@fe/ui/colors'

const baseContainerStyles = {
  zIndex: 2,
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'center',
  height: 64,
  width: '100%'
}

const useContainerStyles = makeStyles(theme => ({
  root: {
    ...baseContainerStyles,
    boxShadow: theme.shadows[2],
    backgroundColor: 'white',
    position: 'fixed',
    bottom: 0,
    left: 0,
    [theme.breakpoints.up('md')]: {
      left: 240,
      width: 'calc(100% - 240px)'
    }
  }
}))

const useContainerStylesNoSticky = makeStyles({ root: baseContainerStyles })

const leftStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-start',
  flex: 1
}

const rightStyle = {
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  justifyContent: 'flex-end',
  flex: 1
}

const fontStyle = {
  fontSize: 16,
  fontWeight: 'bold',
  paddingHorizontal: 8
}

const darkColor = colors.lightGreen
const blandColor = colors.placeholderText

const BottomBar = ({ hideRight = false, hideLeft = false, hideLeftIcon = false, hideRightIcon = false, ...props }) => {
  const stickyContainerStyles = useContainerStyles()
  const noStickyContainerStyles = useContainerStylesNoSticky()
  const containerStyles = props.noSticky ? noStickyContainerStyles : stickyContainerStyles
  const color = props.color || darkColor
  const disabledColor = props.disabledColor || blandColor
  const leftFontColor = props.disabledLeft ? disabledColor : (props.leftColor || color)
  const rightFontColor = props.disabledRight ? disabledColor : (props.rightColor || color)
  const leftIcon = props.leftIcon || <ChevronLeftIcon />
  const rightIcon = props.rightIcon || <ChevronRightIcon />
  return (
    <div className={containerStyles.root}>
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        maxWidth: 1240,
        width: '100%'
      }}
      >
        <div style={{ ...leftStyle }}>
          {!hideLeft && (
            <Button
              disabled={props.disabledLeft}
              onClick={props.disabledLeft ? undefined : props.onLeftClick}
              size='large'
              startIcon={!hideLeftIcon && leftIcon}
              style={{ ...fontStyle, color: props.invertLeft ? colors.white : leftFontColor, backgroundColor: props.invertLeft ? leftFontColor : 'transparent' }}
            >
              {_.isString(props.leftText) ? _.toUpper(props.leftText) : props.leftText}
            </Button>
          )}

        </div>
        <div style={{ ...rightStyle }}>
          {!hideRight && (
            <Button
              disabled={props.disabledRight}
              onClick={props.disabledRight ? undefined : props.onRightClick}
              size='large'
              endIcon={!hideRightIcon && rightIcon}
              style={{ ...fontStyle, color: props.invertRight ? colors.white : rightFontColor, backgroundColor: props.invertRight ? rightFontColor : 'transparent' }}
              loading={props.loading}
              loaderRight
            >
              {_.isString(props.rightText) ? _.toUpper(props.rightText) : props.rightText}
            </Button>
          )}
        </div>
      </div>
    </div>
  )
}

export default BottomBar
